/**
 * leadStages — THE canonical 7-stage pipeline, and the one place its labels
 * live (lifted out of LeadsPage.tsx on 2026-09-24, review M1).
 *
 * 🔒 ONE LIST, TWO SCREENS. This was a private const inside the 4500-line
 * LeadsPage, so the dealer-leads panel had no way to reach it and printed the
 * server's raw token instead — Karan read "quote" and "followup" on one screen
 * and "Quote Shared" and "Follow-up" on the other. Copying the labels into the
 * panel would have been the same defect one release later, when the two copies
 * drift. Import from here; never re-inline these literals.
 *
 * Pipeline-Stage-Overhaul (Jun 29 2026): funnel order cold→followup→quote→neg→Prospect.
 * Stage label for literal `hot` is "Prospect" (verbal-yes/payment-pending), NOT the
 * temperature. L160 A2 (2026-07-13): display-only "Closing" → "Prospect" (enum literal
 * `hot` unchanged). DB enum order is unchanged — see lead-stage-advancer.service.ts.
 * Colors matched 1:1 to Flutter AuraColors stage palette.
 */

export interface LeadStage {
  value: string;
  label: string;
  colorHex: string;
  terminal: boolean;
}

export const LEAD_STAGES: LeadStage[] = [
  { value: 'cold',     label: 'Cold',         colorHex: '#7AA1B5', terminal: false },
  { value: 'followup', label: 'Follow-up',    colorHex: '#C98A3B', terminal: false },
  { value: 'quote',    label: 'Quote Shared', colorHex: '#D66BAE', terminal: false },
  { value: 'neg',      label: 'Negotiation',  colorHex: '#B55A00', terminal: false },
  { value: 'hot',      label: 'Prospect',     colorHex: '#B23A3A', terminal: false },
  { value: 'won',      label: 'Won',          colorHex: '#2F7A5B', terminal: true  },
  { value: 'lost',     label: 'Lost',         colorHex: '#8A2A3A', terminal: true  },
];

/**
 * The stage as a person reads it.
 *
 * 🔒 An unknown token is returned AS IT CAME. A stage this build has never
 * heard of must show up on screen as itself, not as an empty cell or a made-up
 * label — a blank stage column is how a new server stage goes unnoticed.
 */
export function leadStageLabel(value: string | null | undefined): string {
  const token = (value ?? '').trim();
  if (!token) return '—';
  return LEAD_STAGES.find((s) => s.value === token)?.label ?? token;
}
